import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface CornerProps {
  progress?: number;
  position: 'topLeft' | 'topRight' | 'bottomRight' | 'bottomLeft';
  className?: string;
}

const border = 'solid 4px #35C7FF';

const configurations = {
  topLeft: [
    {
      greatherThan: 0,
      style: {
        borderTop: border,
      },
    },
    {
      greatherThan: 99,
      style: {
        borderLeft: border,
      },
    },
  ],
  topRight: [
    {
      greatherThan: 24,
      style: {
        borderTop: border,
      },
    },
    {
      greatherThan: 25,
      style: {
        borderRight: border,
      },
    },
  ],
  bottomRight: [
    {
      greatherThan: 49,
      style: {
        borderRight: border,
      },
    },
    {
      greatherThan: 50,
      style: {
        borderBottom: border,
      },
    },
  ],
  bottomLeft: [
    {
      greatherThan: 74,
      style: {
        borderBottom: border,
      },
    },
    {
      greatherThan: 75,
      style: {
        borderLeft: border,
      },
    },
  ],
};

function Corner(props: CornerProps) {
  const style = useMemo(() => {
    if (!props.progress) return {};

    const config = configurations[props.position];
    let style = {};

    config.forEach((item) => {
      if (props.progress! > item.greatherThan) {
        style = { ...style, ...item.style };
      }
    });

    return style;
  }, [props.progress, props.position]);

  return (
    <div
      className={clsx(
        styles.root,
        props.className,
        styles[`position_${props.position}`]
      )}
      style={style}
    ></div>
  );
}

export default Corner;
